import moment from 'moment-timezone';

export const fileDownload = ( data : any, fileName : string, type? : 'csv' | 'html' | 'json' | 'pdf' | 'svg' | 'xlsx' | 'xml' | 'js' | 'ts' | 'spec.ts', contentType?: string, addTimeStamp: boolean = true ) : void => {
    const momentNow = moment( Date.now() );

    //add timestamp to fileName
    if ( addTimeStamp ) {
        fileName += `__${ momentNow.format( 'YYYYMMDD_HHmmss' ) }`;
    }

    contentType = contentType ?? type;

    switch ( contentType ) {
        case 'csv':
            contentType = 'text/csv';
        case 'text/csv':
            fileName += '.csv';
            break;

        case 'html':
            contentType = 'text/html';
        case 'text/html':
            fileName += '.html';
            break;

        case 'json':
            contentType = 'application/json';
        case 'application/json':
            fileName += '.json';
            break;

        case 'pdf':
            contentType = 'application/pdf';
        case 'application/pdf':
            fileName += '.pdf';
            break;

        case 'svg':
            contentType = 'image/svg+xml';
        case 'image/svg+xml':
            fileName += '.svg';
            break;

        case 'xlsx':
            contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
        case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
            fileName += '.xlsx';
            break;

        case 'xml':
            contentType = 'text/xml';
        case 'text/xml':
            fileName += '.xml';
            break;

        case 'js':
            contentType = 'application/javascript';
        case 'application/javascript':
            fileName += '.js';
            break;

        case 'spec.ts':
            fileName += '.spec';
        case 'ts':
            contentType = 'application/typescript';
        case 'application/typescript':
            fileName += '.ts';
            break;

        default:
            contentType = 'text/plain';
            fileName += '.txt';

    }

    const file = new Blob( [ data ], { type: contentType } );

    // Fix for IE 10
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    if ( window.navigator.msSaveOrOpenBlob ) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        window.navigator.msSaveOrOpenBlob( file, fileName );
    }
    else {
        const a   = document.createElement( 'a' ),
              url = URL.createObjectURL( file );

        a.href = url;
        a.download = fileName;
        document.body.appendChild( a );
        a.click();
        setTimeout( function() {
            document.body.removeChild( a );
            window.URL.revokeObjectURL( url );
        }, 0 );
    }
}
